<div *ngIf="isAuthorised">
  <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
  <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
  <div [ngClass]="filterType === 'version' ? 'card-highlight' : ''">
    <div class="ia-action-div" *ngIf="currentUserRole === 'Compliance Enterprise' || isSavedPermission">
      <span class="cursor-pointer text-primary ml-2 pull-right" *ngIf="filterType !== 'version'"
        (click)="updateImpactAssessment()"><i class="fa fa-floppy-o text-dark"></i>
        Save</span>
      <span *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADRT')"
        class="cursor-pointer text-primary pull-right ml-2">
        <i class="fa fa-square-o icon-font vertical-align-middle" (click)="impactAssessment.isRecordTime = true"
          *ngIf="!impactAssessment.isRecordTime" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font vertical-align-middle" (click)="impactAssessment.isRecordTime = false"
          *ngIf="impactAssessment.isRecordTime" aria-hidden="true"></i>
        Record Time
      </span>
      <span class="cursor-pointer text-primary ml-2 pull-right"
        *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADC') && !impactAssessment.isMerged"
        (click)="openRegulationDialog()"><i class="fa fa-times-circle text-dark"></i> Close Assessment</span>
      <span class="cursor-pointer text-primary ml-2 pull-right"
        *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADC') && impactAssessment.isMerged"
        (click)="openBulkCloseDialog()"><i class="fa fa-times-circle text-dark"></i> Close Assessment</span>
      <span *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADHA')"
        class="cursor-pointer text-primary pull-right ml-2">
        <i class="fa fa-square-o icon-font vertical-align-middle" (click)="impactAssessment.isHidden = true"
          *ngIf="!impactAssessment.isHidden" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font vertical-align-middle" (click)="impactAssessment.isHidden = false"
          *ngIf="impactAssessment.isHidden" aria-hidden="true"></i>
        Hide Assessment
      </span>
      <span *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADSN')"
        class="cursor-pointer text-primary pull-right ml-2">
        <i class="fa fa-square-o icon-font vertical-align-middle" (click)="impactAssessment.isSendNotification = true"
          *ngIf="!impactAssessment.isSendNotification" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font vertical-align-middle"
          (click)="impactAssessment.isSendNotification = false" *ngIf="impactAssessment.isSendNotification"
          aria-hidden="true"></i>
        Send Notification
      </span>
      <span (click)="backToCurrentVersion()" *ngIf="filterType === 'version'"
        class="cursor-pointer text-primary pull-right ml-2"><i class="fa fa-undo text-dark"></i>
        Current Version</span>
      <span class="cursor-pointer text-primary pull-right ml-2" (click)="openDialog()"><i
          class="fa fa-history text-dark"></i> Version History</span>
      <span class="cursor-pointer text-primary pull-right ml-2"
        *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADER')" (click)="downloadReport()"><i
          class="fa fa-download text-dark"></i> Export Report</span>
      <span class="cursor-pointer text-primary pull-right ml-2"
        *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADIR')" (click)="uploadImportReport()"><i
          class="fa fa-upload text-dark"></i>
        <span> Import Report</span>
        <input id="importReport" (change)="handleImportFileInput($event.target.files)" type="file" multiple
          style="display: none" /><br />
      </span>
      <span class="mb-2 text-muted" *ngIf="checkSibling(impactAssessmentId, 'Next')">
        <span class="text-primary float-left" (click)="getSiblings('Next')">Next</span>
      </span>
      <span class="mb-2 text-muted" *ngIf="checkSibling(impactAssessmentId, 'Previous')">
        <span class="text-primary float-left ml-4" (click)="getSiblings('Previous')">Previous</span>
      </span>
    </div>
    <div class="pl-2 ia-details-div" cdkScrollable (scroll)="scrollHandler($event)">
      <mat-accordion id="SummaryDetails">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Summary Details
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row mr-0 ml-0" *ngIf="impactAssessment.isMerged">
            <span class="ml-4 mr-3"><label class="control-label fw inline-block">Assessment Id </label></span>
            <a>
              <span *ngFor="let item of impactAssessment.merged_Id|stringToArray;" (click)="getUpdatedDbInfo(item)">
                <span
                  [ngClass]="this.impactAssessment.updatedDB_Id == item ?  'parent-id':'link-id d-inline-block'">{{item}}<span
                    class="cursor-pointer ml-1"
                    *ngIf="this.impactAssessment.updatedDB_Id != item && (currentUserRole === 'Compliance Enterprise' || isSavedPermission)"
                    (click)="updateOtherMergedId(item)"><i class="fa fa-times-circle text-white"></i></span></span>
              </span>
            </a>
            <span class="parent-span">
              <label class="control-label fw mr-2 inline-block"> Parent Id </label>
              <span *ngIf="!isParentIdEdit" class="control-label inline-block">{{impactAssessment.updatedDB_Id}}</span>
              <span *ngIf="!isParentIdEdit" class="cursor-pointer text-primary ml-2" (click)="updateParentId()">
                Edit</span>
              <span *ngIf="isParentIdEdit" class="inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="parentId">
                  <option *ngFor="let item of impactAssessment.merged_Id|stringToArray;" value="{{item}}">{{item}}
                  </option>
                </select>
              </span>
              <span *ngIf="isParentIdEdit" class="cursor-pointer text-primary ml-2" (click)="changeParentId()">Confirm
              </span>
            </span>
          </div>
          <div class="row form-group ml-2 mt-1">
            <div class="col-lg-2 col-md-1 mx-width-10pr">
              <label class="control-label fw"> {{ impactAssessment.isMerged? "Id":"Assessment Id" }}</label>
              <div class="control-label" name="ids">{{ this.currentinfoId }}</div>
            </div>
            <div class="col-lg-5 col-md-5 mx-width-40pr">
              <label class="control-label fw">Title</label>
              <div class="control-label div-scroll" name="title">{{ impactAssessment.title }}</div>
            </div>
            <div class="col-lg-2 mx-width-11pr">
              <label class="control-label fw">Type</label>
              <div class="control-label" name="title">{{ impactAssessment.pubType }}</div>
            </div>
            <div class="col-lg-1 mx-width-8pr">
              <label class="control-label fw">Geography</label>
              <div class="control-label">{{impactAssessment.geography}}</div>
            </div>
            <div class="col-lg-2 mx-width-8pr">
              <label class="control-label fw">Country</label>
              <div class="control-label">{{impactAssessment.country}}</div>
            </div>
            <div class="col-lg-1 mx-width-8pr">
              <label class="control-label fw">Regulator</label>
              <div class="control-label">{{impactAssessment.regulator}}</div>
            </div>
            <div class="col-lg-1 mx-width-8pr">
              <label class="control-label fw">Date</label>
              <div class="control-label">{{impactAssessment.updatedDB_Date | date: 'dd-MMM-yyyy' }}</div>
            </div>
            <div class="col-lg-1 mx-width-7pr"
              *ngIf="impactAssessment.isRecordTime && commonService.checkPlanTypeAction('IADRT')">
              <label class="control-label fw">Time Spent </label>
              <div class="control-label">{{impactAssessment.timeSpent | minToHour}}</div>
            </div>
          </div>

          <div class="row ml-2">
            <div class="col-lg-9">
              <div class="row">
                <div class="col-lg-9 fw">
                  <label class="control-label fw">Description</label>
                </div>
                <div class="col-lg-3" *ngIf="impactAssessment.hyperlink">
                  <a href="{{impactAssessment.hyperlink}}" class=" pull-right" target="_blank">
                    <i class="fa fa-globe"></i>
                    <span class="text-primary cursor-pointer">
                      Source Link</span>
                  </a>
                </div>
                <div class="col-lg-3" *ngIf="!impactAssessment.hyperlink">
                  <span class="pull-right"><i class="fa fa-globe"></i><span> Source Link</span></span>
                </div>
                <div class="col-lg-12 edit_status_changeViewer_group">
                  <div class="edit_status_changeViewer_group"
                    *ngIf="impactAssessment.description && impactAssessment.description.indexOf('<div') < 0">
                    <mat-form-field class="disableText w-100">
                      <textarea matInput [(ngModel)]="impactAssessment.description" class="text-area-css"
                        cdkTextareaAutosize disabled [innerHTML]="impactAssessment.description"></textarea>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-12 desc-text-box"
                    *ngIf="impactAssessment.description && impactAssessment.description.indexOf('<div') >= 0">
                    <div [innerHtml]="impactAssessment.description"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 desc-text-box" *ngIf="currentinfoId > 0">
              <app-current-action [userId]="userAccessToken.userId" [itemId]="currentinfoId" [closedType]="'Assess'">
              </app-current-action>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="AdditionalDetails">
        <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Additional Details
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row align-items-center ml-2 mt-1">
            <div class="col-lg-2">
              <label class="control-label fw">Division</label>
              <ng-select disabled *ngIf="searchedJuris.length > 0" [items]="searchedJuris" bindLabel="name"
                appendTo="body" [multiple]="true" [(ngModel)]="selectedJuris">
              </ng-select>
            </div>

            <div class="col-lg-4" *ngIf="impactAssessment.templateNo==3">
              <label class="control-label fw">Legal Entity</label>
              <mat-chip-grid #legalEntityList>
                <mat-chip-row *ngFor="let entity of selectedEntity|stringToArrayParent" [selectable]="selectable"
                  [removable]="removable" (removed)="removeLegalEntity(entity)">
                  {{entity}}
                  <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">clear
                  </mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  #trigautoLegalEntity="matAutocompleteTrigger"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" #LegalEntityInput
                  [formControl]="searchLegalEntityCntrl" [matAutocomplete]="legalEntityAutocomplete"
                  [matChipInputFor]="legalEntityList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addLegalEntity($event)">
              </mat-chip-grid>
              <mat-autocomplete #legalEntityAutocomplete="matAutocomplete"
                (optionSelected)="selectedLegalEntityEvent($event)">
                <mat-option *ngFor="let item of legalEntityDD" [value]="item.title">
                  {{item.title}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4" *ngIf="impactAssessment.templateNo!=3">
              <label class="control-label fw">Legal Entity</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="impactAssessment.legalEntity"
                *ngIf="impactAssessment.templateNo!=3" />
            </div>

            <div class="col-lg-2">
              <label class="control-label fw">Rule Type</label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.ruleType">
                <option *ngFor="let option of ruleType" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-2">
              <label class="control-label fw">Effective Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="picker" (click)="picker.open()"
                  class="form-control form-control-sm border-bottom" name="applicationDate"
                  [(ngModel)]="impactAssessment.applicationDate">
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
                </div>
              </div>
              <mat-datepicker #picker></mat-datepicker>
            </div>
            <div class="col-lg-2">
              <button class="btn bg-g-lightGreen btn-sm" (click)="openLADialog()">Linked Assessments</button>
              <div class="mt-1" *ngIf="impactAssessment.previousImpactAsss_Id">
                <div class="link-div mb-1" *ngFor="let linkedAId of linkedAssessmentIds">
                  <a class="link-id" (click)="openLinkedAssessment(linkedAId.id)"
                    *ngIf="!linkedAId.isMerged">{{linkedAId.updatedDbId}}</a>
                  <a class="link-id" (click)="openLinkedAssessment(linkedAId.id)"
                    *ngIf="linkedAId.isMerged">{{linkedAId.merged_Id}}</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mt-1" *ngIf="impactAssessment.templateNo==3">
              <label class="control-label fw">Line of Business</label>
              <mat-chip-grid #lineOfBusinessList>
                <mat-chip-row *ngFor="let entity of impactAssessment.lineOfBusiness|stringToArrayParent"
                  [selectable]="selectable" [removable]="removable" (removed)="removeLineOfBusiness(entity)">
                  {{entity}}
                  <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">clear
                  </mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  #trigautoLineOfBusiness="matAutocompleteTrigger"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" #LineOfBusinessInput
                  [formControl]="searchLineOfBusinessCntrl" [matAutocomplete]="lineOfBusinessAutocomplete"
                  [matChipInputFor]="lineOfBusinessList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addLineOfBusiness($event)">
              </mat-chip-grid>
              <mat-autocomplete #lineOfBusinessAutocomplete="matAutocomplete"
                (optionSelected)="selectedLineOfBusinessEvent($event)">
                <mat-option *ngFor="let item of lineOfBusiness" [value]="item">
                  {{item}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <!-- Line of Business removed from template 1 - Amit Madahar 30 May 2023-->
            <!-- <div class="col-lg-6 mt-1"  *ngIf="impactAssessment.templateNo==2 || impactAssessment.templateNo==1"> -->
            <div class="col-lg-6 mt-1" *ngIf="impactAssessment.templateNo==2">
              <label class="control-label fw">Line of Business</label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                (change)="updateSectionLastEdited('LineOfBusiness')" [(ngModel)]="impactAssessment.lineOfBusiness">
                <option *ngFor="let option of lineOfBusiness" value="{{option}}">{{option}}</option>
              </select>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-1">
              <div>
                <label class="control-label mx-auto fw">Topic</label>
              </div>

              <label class="cursor-pointer text-primary" (click)="deleteAllTopic()">Delete All</label>
            </div>
            <div class="col-lg-11 topic-list">
              <mat-chip-grid #topicList class="myChip">
                <!-- <ng-container *ngFor="let item of this.impactAssessment.ruleTopic|jsonStringToArray">
                  <mat-chip-row [style.background-color]="item[0]" *ngFor="let TopicItemName of sortArray(item[1])"
                    [selectable]="selectable" [removable]="removable" (removed)="removeTopic(TopicItemName)">
                    <span [style.color]="getContrastYIQ(item[0])">{{TopicItemName}}</span>
                    <mat-icon matChipRemove *ngIf="removable" [style.color]="getContrastYIQ(item[0])"
                      class="clear-icons">clear</mat-icon>
                  </mat-chip-row>
                </ng-container> -->
                <mat-chip-row *ngFor="let TopicItemName of myTopicDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeTopic(TopicItemName)">
                  {{TopicItemName}}
                  <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">clear
                  </mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom display-inline w-300px"
                  #trigautoTopic="matAutocompleteTrigger" (keydown)="getFilteredData('Topic', $event)" #topicInput
                  [formControl]="searchTopicCntrl" [matAutocomplete]="topicAutoComplete" [matChipInputFor]="topicList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                  autocomplete="off" (matChipInputTokenEnd)="addTopic($event)">
              </mat-chip-grid>
              <mat-autocomplete #topicAutoComplete="matAutocomplete" (optionSelected)="selectedTopicEvent($event)">
                <mat-option *ngFor="let item of searchedTopics" [value]="item.value">
                  {{item.name}}
                </mat-option>
              </mat-autocomplete>

            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Template 1 -->
      <div *ngIf="impactAssessment.templateNo==1 || impactAssessment.templateNo==0">
        <app-progress-bar [isLoading]="isLoadingDD"></app-progress-bar>
        <mat-accordion id="AssessmentDetails">
          <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
            <mat-expansion-panel-header class="ia-mat-panel">
              <mat-panel-title>
                <span class="text-header inc-f">
                  Assessment Details
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row ml-2 my-4">
              <div class="col-lg-4">
                <label class="control-label fw">Assessment Team</label>
                <input type="text" class="form-control form-control-sm"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                  (keyup)="updateSectionLastEdited('AssessmentTeam')" [(ngModel)]="impactAssessment.assessmentTeam">
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Assessor</label>
                <mat-chip-grid #assessorList>
                  <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable" [removable]="removable"
                    (removed)="removeAssessor(assessor)">
                    {{assessor}}
                    <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">clear
                    </mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom"
                    #trigautoAssessor="matAutocompleteTrigger" (keydown)="getFilteredData('Assessor', $event)"
                    [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorInput
                    [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                    [matChipInputFor]="assessorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addAssessor($event)">
                </mat-chip-grid>
                <mat-autocomplete #assessorAutocomplete="matAutocomplete"
                  (optionSelected)="selectedAssessorEvent($event)">
                  <mat-option *ngFor="let assessor of searchedAssessor" [value]="assessor.value">
                    {{assessor.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Assessor Delegate</label>
                <mat-chip-grid #assessorDelList>
                  <mat-chip-row *ngFor="let assessor of assessorDelDD" [selectable]="selectable" [removable]="removable"
                    (removed)="removeAssessorDelegate(assessor)">
                    {{assessor}}
                    <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">clear
                    </mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom"
                    #trigautoAssessorDelegate="matAutocompleteTrigger"
                    (keydown)="getFilteredData('AssessorDelegate', $event)"
                    [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorDelInput
                    [formControl]="searchAssessorDelCntrl" [matAutocomplete]="assessorDelAutocomplete"
                    [matChipInputFor]="assessorDelList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                    (matChipInputTokenEnd)="addAssessorDelegate($event)">
                </mat-chip-grid>
                <mat-autocomplete #assessorDelAutocomplete="matAutocomplete"
                  (optionSelected)="selectedAssessorDelegateEvent($event)">
                  <mat-option *ngFor="let assessor of searchedAssessorDel" [value]="assessor.value">
                    {{assessor.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="row ml-2 mt-1">
              <div class="col-lg-12">
                <div class="box-shadow p-2">
                  <div class="header-text">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                      (click)="isIADetails1 = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                      (click)="isIADetails1 = false"></span>
                    <span class="control-label fw">
                      Publication Proposal - Please provide a summary of what the publication is proposing
                    </span>
                  </div>
                  <div class="text-area-css overflow-auto"
                    *ngIf="iaDetailHistory && iaDetailHistory.assessmentDetails1.length > 0">
                    <div *ngFor="let detailItem of iaDetailHistory.assessmentDetails1">
                      <div class="pt-3" *ngIf="detailItem.itemTitle">
                        <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-css overflow-auto disabled-div"
                    *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.assessmentDetails1.length === 0"
                    [innerHTML]="impactAssessment.assessmentDetails1"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails1" id="assessmentDetails1"
                    [data]="impactAssessment.assessmentDetails1" class="f-16"
                    *ngIf="isADetailPermission && isIADetails1"
                    (keyUpEvent)="updateSectionLastEdited('Assessment')"></app-ck-editor>
                  <!-- <ckeditor [editor]="Editor" id="assessmentDetails1" class="f-16"
                    *ngIf="isADetailPermission && isIADetails1" [(ngModel)]="impactAssessment.assessmentDetails1"
                    (keyup)="updateSectionLastEdited('Assessment')">
                  </ckeditor> -->
                </div>
              </div>
            </div>
            <div class="row ml-2 mt-1">
              <div class="col-lg-12">
                <div class="box-shadow p-2">
                  <div class="header-text">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails2"
                      (click)="isIADetails2 = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails2"
                      (click)="isIADetails2 = false"></span>
                    <span class="control-label fw">
                      Impact - Please provide a summary of publication's impact on
                      business/operational/processes/policies
                    </span>
                  </div>
                  <div class="text-area-css overflow-auto"
                    *ngIf="iaDetailHistory && iaDetailHistory.assessmentDetails2.length > 0">
                    <div *ngFor="let detailItem of iaDetailHistory.assessmentDetails2">
                      <div class="pt-3" *ngIf="detailItem.itemTitle">
                        <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-css overflow-auto disabled-div"
                    *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.assessmentDetails2.length === 0"
                    [innerHTML]="sanitizeHtml(impactAssessment.assessmentDetails2)"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails2" id="assessmentDetails2"
                    [data]="impactAssessment.assessmentDetails2" class="f-16"
                    *ngIf="isADetailPermission && isIADetails2"
                    (keyUpEvent)="updateSectionLastEdited('Assessment')"></app-ck-editor>
                  <!-- <ckeditor [editor]="Editor" id="assessmentDetails2" class="f-16"
                    *ngIf="isADetailPermission && isIADetails2" [(ngModel)]="impactAssessment.assessmentDetails2"
                    (keyup)="updateSectionLastEdited('Assessment')">
                  </ckeditor> -->
                </div>
              </div>
            </div>
            <div class="row ml-2 mt-1">
              <div class="col-lg-3">
                <label class="control-label fw">Capital/RWA Impact</label>
                <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.capitalRWAImpact">
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div class="col-lg-3">
                <label class="control-label fw">
                  Impact Rating Lite
                  <span class="label label-default bg-default p5-20"
                    *ngIf="!impactAssessment.impactRatingLite">None</span>
                  <span class="label label-default bg-red p5-20"
                    *ngIf="impactAssessment.impactRatingLite === 'Very High'">Very
                    High</span>
                  <span class="label ml-2 label-default bg-orange p5-20"
                    *ngIf="impactAssessment.impactRatingLite === 'High'">High</span>
                  <span class="label ml-2 label-default bg-yellow p5-20"
                    *ngIf="impactAssessment.impactRatingLite === 'Medium'">Medium</span>
                  <span class="label ml-2 label-default bg-green p5-20"
                    *ngIf="impactAssessment.impactRatingLite === 'Low'">Low</span>
                </label>
                <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.impactRatingLite">
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                  <option value="Very High">Very High</option>
                </select>
              </div>
              <div class="col-lg-3">
                <a class="btn bg-g-lightGreen btn-sm" *ngIf="!isADetailPermission">Impact Rating Detail</a>
                <button class="btn bg-g-lightGreen btn-sm" [attr.disabled]="!isImpactRating ? true: null"
                  *ngIf="isADetailPermission" (click)="openImpactRating()">
                  Impact Rating Detail</button>
                <div class="mt-1">
                  <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.impactRating">Not
                    Performed</span>
                  <span class="label label-default bg-red p5-20"
                    *ngIf="impactAssessment.impactRating === 'Very High'">Very
                    High</span>
                  <span class="label ml-2 label-default bg-orange p5-20"
                    *ngIf="impactAssessment.impactRating === 'High'">High</span>
                  <span class="label ml-2 label-default bg-yellow p5-20"
                    *ngIf="impactAssessment.impactRating === 'Medium'">Medium</span>
                  <span class="label ml-2 label-default bg-green p5-20"
                    *ngIf="impactAssessment.impactRating === 'Low'">Low</span>
                </div>
              </div>
            </div>
            <div class="row ml-2 mt-1">
              <div class="col-lg-12">
                <div class="box-shadow p-2">
                  <div class="header-text">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails3"
                      (click)="isIADetails3 = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails3"
                      (click)="isIADetails3 = false"></span>
                    <span class="control-label fw">
                      Actions Required - Please provide a summary of the actions needed to comply with publication
                      proposal
                    </span>
                  </div>
                  <div class="text-area-css overflow-auto"
                    *ngIf="iaDetailHistory && iaDetailHistory.actionRequired.length > 0">
                    <div *ngFor="let detailItem of iaDetailHistory.actionRequired">
                      <div class="pt-3" *ngIf="detailItem.itemTitle">
                        <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-css overflow-auto disabled-div"
                    *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.actionRequired.length === 0"
                    [innerHTML]="impactAssessment.actionRequired"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.actionRequired" id="actionRequired" class="f-16"
                    [data]="impactAssessment.actionRequired" *ngIf="isADetailPermission && isIADetails3"
                    (keyUpEvent)="updateSectionLastEdited('Assessment')"></app-ck-editor>
                  <!-- <ckeditor [editor]="Editor" id="actionRequired" class="f-16" *ngIf="isADetailPermission && isIADetails3"
                    [(ngModel)]="impactAssessment.actionRequired" (keyup)="updateSectionLastEdited('Assessment')">
                  </ckeditor> -->
                </div>
              </div>
            </div>
            <div class="row ml-2 my-4">
              <div class="col-lg-6">
                <label class="control-label fw">Implementation Type</label>
                <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                  (change)="updateSectionLastEdited('ImplementationType')"
                  [(ngModel)]="impactAssessment.implementationType">
                  <option *ngFor="let option of implementationType" value="{{option}}">{{option}}</option>
                </select>
              </div>
              <div class="col-lg-6">
                <label class="control-label fw">Project Reference</label>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="impactAssessment.projectReference"
                  [matAutocomplete]="auto" (change)="setProjectPreference()">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" class="refernce-autocomplete">
                  <mat-option [value]="'Not Applicable'">
                    Not Applicable
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="row ml-2 my-4">
              <div class="col-lg-4">
                <label class="control-label fw">Next Action Date</label>
                <div class="input-group input-group-sm">
                  <input matInput [matDatepicker]="assessmentDueDate"
                    [attr.disabled]="!isADetailPermission ? 'disabled' : null" (click)="assessmentDueDate.open()"
                    class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.assessmentDueDate"
                    name="AssessmentDueDate" (dateInput)="updateSectionLastEdited('Assessment')" />
                  <div class="input-group-append">
                    <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                      (click)="assessmentDueDate.open()"></span>
                    <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                  </div>
                </div>
                <mat-datepicker #assessmentDueDate (selectedChanged)="updateSectionLastEdited('Assessment')">
                </mat-datepicker>
              </div>
              <div class="col-lg-8">
                <label class="control-label fw">Next Action Step</label>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="impactAssessment.nextActionStep" />
              </div>
            </div>
            <div class="row ml-2 my-4">
              <div class="col-lg-4">
                <label class="control-label fw">Assessment Status</label>
                <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                  (change)="updateSectionLastEdited('AssessmentStatus')"
                  [(ngModel)]="impactAssessment.assessmentStatus">
                  <option *ngFor="let option of assessmentStatus" value="{{option}}">{{option}}</option>
                </select>
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Assessment Last Edited</label>
                <div class="input-group input-group-sm">
                  <input matInput [matDatepicker]="assessmentLastEdited" disabled (click)="assessmentLastEdited.open()"
                    class="form-control form-control-sm border-bottom"
                    [(ngModel)]="impactAssessment.assessmentLastEdited" name="AssessmentLastEdited" />
                  <div class="input-group-append">
                    <span class="input-group-text fa fa-calendar" disabled (click)="assessmentLastEdited.open()"></span>
                  </div>
                </div>
                <mat-datepicker #assessmentLastEdited></mat-datepicker>
              </div>
            </div>
            <div class="row ml-2 pt-3">
              <span class="text-primary ml-1 fw" *ngIf="!isADetailPermission">Upload Evidence - Assessment</span>
              <div class="col-lg-3 cursor-pointer" *ngIf="isADetailPermission" (click)="uploadEvidenceAssessment()">
                <i class="fa fa-upload"></i>
                <span class="text-primary ml-1 fw">Upload Evidence - Assessment
                  <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
                </span>
                <input id="uploadEviAssessment" #myFileInput1 (change)="handleFileInput($event.target.files)"
                  type="file" multiple style="display: none" /><br />
              </div>
              <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                <ng-container *ngFor="let docs of impactAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === 1">
                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isADetailPermission"
                      (click)="openDeleteModel(docs.id, 'Assessment')"></span>
                    <span class="cursor-pointer"
                      (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Assessment')">
                      <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                      <i class="fa fa-file-text-o fa-2x"
                        *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                      <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                      <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                      <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                      <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                      <i class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                    </span>
                    <div class="data-div">{{docs.fileName}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion id="ReviewDetails">
          <mat-expansion-panel class="ia-expansion-panel pl-2 mt-2">
            <mat-expansion-panel-header class="ia-mat-panel">
              <mat-panel-title>
                <span class="text-header inc-f">
                  Review Details
                </span>
                <span *ngIf="filterType !== 'version' && isRDPermission" class="cursor-pointer ml-3"
                  style="font-size:14px">
                  <i class="fa fa-square-o icon-font vertical-align-top" (click)="checkReviewDetailRequired('Checked')"
                    *ngIf="!impactAssessment.isReviewRequired" aria-hidden="true"></i>
                  <i class="fa fa-check-square icon-font vertical-align-top"
                    (click)="checkReviewDetailRequired('UnChecked')" *ngIf="impactAssessment.isReviewRequired"
                    aria-hidden="true"></i>
                  Not Required
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row ml-2 mt-1">
              <div class="col-lg-4">
                <label class="control-label fw">Reviewer Team</label>
                <input type="text" [attr.disabled]="!isRDetailPermission ? 'disabled' : null"
                  (keyup)="updateSectionLastEdited('ReviewerTeam')" class="form-control form-control-sm"
                  [(ngModel)]="impactAssessment.reviewTeam" />
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Reviewer</label>
                <mat-chip-grid #reviewerList>
                  <mat-chip-row *ngFor="let reviewer of reviewerDD" [selectable]="selectable" [removable]="removable"
                    (removed)="removeReviewer(reviewer)">
                    {{reviewer}}
                    <mat-icon matChipRemove *ngIf="removable && isRDetailPermission" class="clear-icons">clear
                    </mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom"
                    #trigautoReviewer="matAutocompleteTrigger" (keydown)="getFilteredData('Reviewer', $event)"
                    [attr.disabled]="!isRDetailPermission ? 'disabled' : null" #reviewerInput
                    [formControl]="searchReviewerCntrl" [matAutocomplete]="reviewerAutocomplete"
                    [matChipInputFor]="reviewerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addReviewer($event)">
                </mat-chip-grid>
                <mat-autocomplete #reviewerAutocomplete="matAutocomplete"
                  (optionSelected)="selectedReviewerEvent($event)">
                  <mat-option *ngFor="let reviewer of searchedReviewer" [value]="reviewer.value">
                    {{reviewer.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Reviewer Delegate</label>
                <mat-chip-grid #reviewerDelList>
                  <mat-chip-row *ngFor="let reviewer of reviewerDelDD" [selectable]="selectable" [removable]="removable"
                    (removed)="removeReviewerDelegate(reviewer)">
                    {{reviewer}}
                    <mat-icon matChipRemove *ngIf="removable && isRDetailPermission" class="clear-icons">clear
                    </mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom"
                    #trigautoReviewerDelegate="matAutocompleteTrigger"
                    (keydown)="getFilteredData('ReviewerDelegate', $event)"
                    [attr.disabled]="!isRDetailPermission ? 'disabled' : null" #reviewerDelInput
                    [formControl]="searchReviewerDelCntrl" [matAutocomplete]="reviewerDelAutocomplete"
                    [matChipInputFor]="reviewerDelList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                    (matChipInputTokenEnd)="addReviewerDelegate($event)">
                </mat-chip-grid>
                <mat-autocomplete #reviewerDelAutocomplete="matAutocomplete"
                  (optionSelected)="selectedReviewerDelegateEvent($event)">
                  <mat-option *ngFor="let reviewer of searchedReviewerDel" [value]="reviewer.value">
                    {{reviewer.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="row ml-2 mt-1">
              <div class="col-lg-4">
                <label class="control-label fw">Reviewer Due Date</label>
                <div class="input-group input-group-sm">
                  <input matInput [matDatepicker]="reviewDueDate"
                    [attr.disabled]="!isRDetailPermission ? 'disabled' : null" (click)="reviewDueDate.open()"
                    class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.reviewDueDate"
                    name="ReviewDueDate" (dateInput)="updateSectionLastEdited('Review')" />
                  <div class="input-group-append">
                    <span class="input-group-text fa fa-calendar" *ngIf="isRDetailPermission"
                      (click)="reviewDueDate.open()"></span>
                    <span class="input-group-text fa fa-calendar" *ngIf="!isRDetailPermission"></span>
                  </div>
                </div>
                <mat-datepicker #reviewDueDate></mat-datepicker>
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Reviewer Last Edited</label>
                <div class="input-group input-group-sm">
                  <input matInput [matDatepicker]="reviewLastEdited" disabled (click)="reviewLastEdited.open()"
                    class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.reviewLastEdited"
                    name="ReviewLastEdited" />
                  <div class="input-group-append">
                    <span class="input-group-text fa fa-calendar" disabled (click)="reviewLastEdited.open()"></span>
                  </div>
                </div>
                <mat-datepicker #reviewLastEdited></mat-datepicker>
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Review Status</label>
                <select class="form-control form-control-sm" [attr.disabled]="!isRDetailPermission ? 'disabled' : null"
                  (change)="updateSectionLastEdited('ReviewStatus')" [(ngModel)]="impactAssessment.reviewStatus">
                  <option *ngFor="let option of reviewStatus" value="{{option}}">{{option}}</option>
                </select>
              </div>
            </div>
            <div class="row ml-2 mt-1">
              <div class="col-lg-12">
                <div class="box-shadow p-2">
                  <div class="header-text">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="isRDetailPermission && !isRDetails"
                      (click)="isRDetails = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isRDetailPermission && isRDetails"
                      (click)="isRDetails = false"></span>
                    <span class="control-label fw">
                      Review Details
                    </span>
                  </div>
                  <div class="text-area-css overflow-auto"
                    *ngIf="iaDetailHistory && iaDetailHistory.reviewDetails.length > 0">
                    <div *ngFor="let detailItem of iaDetailHistory.reviewDetails">
                      <div class="pt-3" *ngIf="detailItem.itemTitle">
                        <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-css overflow-auto disabled-div"
                    *ngIf="!isRDetailPermission && iaDetailHistory && iaDetailHistory.reviewDetails.length === 0"
                    [innerHTML]="impactAssessment.reviewDetails"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.reviewDetails" id="reviewDetails" class="f-16"
                    [data]="impactAssessment.reviewDetails" *ngIf="isRDetails"
                    (keyUpEvent)="updateSectionLastEdited('Review')"></app-ck-editor>
                  <!-- <ckeditor [editor]="Editor" id="reviewDetails" class="f-16" *ngIf="isRDetails"
                    [(ngModel)]="impactAssessment.reviewDetails" (keyup)="updateSectionLastEdited('Review')">
                  </ckeditor> -->
                </div>
              </div>
            </div>
            <div class="row ml-2 pt-3">
              <span class="text-primary ml-1 fw" *ngIf="!isRDetailPermission">Upload Evidence - Review</span>
              <div class="col-lg-3 cursor-pointer" *ngIf="isRDetailPermission" (click)="uploadEvidenceReview()">
                <i class="fa fa-upload"></i>
                <span class="text-primary ml-1 fw">Upload Evidence - Review
                  <i *ngIf="isReviewLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
                </span>
                <input id="uploadEviReview" #myFileInput2 (change)="handleReviewInput($event.target.files)" type="file"
                  multiple style="display: none" /><br />
              </div>
              <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                <ng-container *ngFor="let docs of impactAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === 2">
                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isRDetailPermission"
                      (click)="openDeleteModel(docs.id, 'Review')"></span>
                    <span class="cursor-pointer"
                      (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Review')">
                      <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                      <i class="fa fa-file-text-o fa-2x"
                        *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                      <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                      <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                      <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                      <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                      <i class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                    </span>
                    <div class="data-div">{{docs.fileName}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion id="ImplementationDetails">
          <mat-expansion-panel class="ia-expansion-panel pl-2 mt-2">
            <mat-expansion-panel-header class="ia-mat-panel">
              <mat-panel-title>
                <span class="text-header inc-f">
                  Implementation Details
                </span>
                <span *ngIf="filterType !== 'version' && isIDPermission" class="cursor-pointer ml-3"
                  style="font-size:14px">
                  <i class="fa fa-square-o icon-font vertical-align-top"
                    (click)="checkImplementationDetailRequired('Checked')"
                    *ngIf="!impactAssessment.isImplementationRequired" aria-hidden="true"></i>
                  <i class="fa fa-check-square icon-font vertical-align-top"
                    (click)="checkImplementationDetailRequired('UnChecked')"
                    *ngIf="impactAssessment.isImplementationRequired" aria-hidden="true"></i>
                  Not Required
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row ml-2 mt-1">
              <div class="col-lg-4">
                <label class="control-label fw">Implementation Team</label>
                <input type="text" [attr.disabled]="!isIDetailPermission ? 'disabled' : null"
                  (keyup)="updateSectionLastEdited('ImplementationTeam')" class="form-control form-control-sm"
                  [(ngModel)]="impactAssessment.implementationTeam" />
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Implementation Owner</label>
                <mat-chip-grid #imptList>
                  <mat-chip-row *ngFor="let implmt of imptOwnerDD" [selectable]="selectable" [removable]="removable"
                    (removed)="removeImplementationOwner(implmt)">
                    {{implmt}}
                    <mat-icon matChipRemove *ngIf="removable && isIDetailPermission" class="clear-icons">clear
                    </mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom"
                    #trigautoImpOwner="matAutocompleteTrigger" (keydown)="getFilteredData('Owner', $event)"
                    [attr.disabled]="!isIDetailPermission ? 'disabled' : null" #imptOwnerInput
                    [formControl]="searchImptOwnerCntrl" [matAutocomplete]="imptOwnerAutocomplete"
                    [matChipInputFor]="imptList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                    (matChipInputTokenEnd)="addImplementationOwner($event)">
                </mat-chip-grid>
                <mat-autocomplete #imptOwnerAutocomplete="matAutocomplete"
                  (optionSelected)="selectedImplementationOwnerEvent($event)">
                  <mat-option *ngFor="let implmt of searchedImptOwner" [value]="implmt.value">
                    {{implmt.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Owner Delegate</label>
                <mat-chip-grid #ownerDelList>
                  <mat-chip-row *ngFor="let owner of ownerDelDD" [selectable]="selectable" [removable]="removable"
                    (removed)="removeOwnerDel(owner)">
                    {{owner}}
                    <mat-icon matChipRemove *ngIf="removable && isIDetailPermission" class="clear-icons">clear
                    </mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom"
                    #trigautoOwnerDelegate="matAutocompleteTrigger" (keydown)="getFilteredData('OwnerDelegate', $event)"
                    [attr.disabled]="!isIDetailPermission ? 'disabled' : null" #ownerDelInput
                    [formControl]="searchOwnerDelCntrl" [matAutocomplete]="ownerDelAutocomplete"
                    [matChipInputFor]="ownerDelList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addOwnerDel($event)">
                </mat-chip-grid>
                <mat-autocomplete #ownerDelAutocomplete="matAutocomplete"
                  (optionSelected)="selectedOwnerDelEvent($event)">
                  <mat-option *ngFor="let owner of searchedOwnerDel" [value]="owner.value">
                    {{owner.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="row ml-2 mt-1">
              <div class="col-lg-4">
                <label class="control-label fw">Implementation Due Date</label>
                <div class="input-group input-group-sm">
                  <input matInput [matDatepicker]="implementationDueDate"
                    [attr.disabled]="!isIDetailPermission ? 'disabled' : null" (click)="implementationDueDate.open()"
                    class="form-control form-control-sm border-bottom"
                    [(ngModel)]="impactAssessment.implementationDueDate" name="ImplementationDueDate"
                    (dateInput)="updateSectionLastEdited('Implementation')" />
                  <div class="input-group-append">
                    <span class="input-group-text fa fa-calendar" *ngIf="isIDetailPermission"
                      (click)="implementationDueDate.open()"></span>
                    <span class="input-group-text fa fa-calendar" *ngIf="!isIDetailPermission"></span>
                  </div>
                </div>
                <mat-datepicker #implementationDueDate></mat-datepicker>
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Implementation Last Edited</label>
                <div class="input-group input-group-sm">
                  <input matInput [matDatepicker]="implementationLastEdited" disabled
                    (click)="implementationLastEdited.open()" class="form-control form-control-sm border-bottom"
                    [(ngModel)]="impactAssessment.implementationLastEdited" name="ImplementationLastEdited" />
                  <div class="input-group-append">
                    <span class="input-group-text fa fa-calendar" disabled
                      (click)="implementationLastEdited.open()"></span>
                  </div>
                </div>
                <mat-datepicker #implementationLastEdited></mat-datepicker>
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Implementation Status</label>
                <select class="form-control form-control-sm" [attr.disabled]="!isIDetailPermission ? 'disabled' : null"
                  (change)="updateSectionLastEdited('ImplementationStatus')"
                  [(ngModel)]="impactAssessment.implementationStatus">
                  <option *ngFor="let option of implementationStatus" value="{{option}}">{{option}}</option>
                </select>
              </div>
            </div>

            <div class="row ml-2 mt-1">
              <div class="col-lg-12">
                <div class="box-shadow p-2">
                  <div class="header-text">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="isIDetailPermission && !isIDetails"
                      (click)="isIDetails = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIDetailPermission && isIDetails"
                      (click)="isIDetails = false"></span>
                    <span class="control-label fw">
                      Implementation Details
                    </span>
                  </div>
                  <div class="text-area-css overflow-auto"
                    *ngIf="iaDetailHistory && iaDetailHistory.implementationDetails.length > 0">
                    <div *ngFor="let detailItem of iaDetailHistory.implementationDetails">
                      <div class="pt-3" *ngIf="detailItem.itemTitle">
                        <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-css overflow-auto disabled-div"
                    *ngIf="!isIDetailPermission && iaDetailHistory && iaDetailHistory.implementationDetails.length === 0"
                    [innerHTML]="impactAssessment.implementationDetails"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.implementationDetails" id="implementationDetails"
                    [data]="impactAssessment.implementationDetails" class="f-16" *ngIf="isIDetails"
                    (keyUpEvent)="updateSectionLastEdited('Implementation')"></app-ck-editor>
                  <!-- <ckeditor [editor]="Editor" id="implementationDetails" class="f-16" *ngIf="isIDetails"
                    [(ngModel)]="impactAssessment.implementationDetails"
                    (keyup)="updateSectionLastEdited('Implementation')">
                  </ckeditor> -->
                </div>
              </div>
            </div>
            <div class="row ml-2 pt-3">
              <span class="text-primary ml-1 fw" *ngIf="!isIDetailPermission">Upload Evidence - Review</span>
              <div class="col-lg-3 cursor-pointer" *ngIf="isIDetailPermission" (click)="uploadEvidenceImplementation()">
                <i class="fa fa-upload"></i>
                <span class="text-primary ml-1 fw">Upload Evidence - Implementation
                  <i *ngIf="isImplementationLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
                </span>
                <input id="uploadEviImplementation" #myFileInput3
                  (change)="handleImplementationInput($event.target.files)" type="file" multiple
                  style="display: none" /><br />
              </div>
              <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                <ng-container *ngFor="let docs of impactAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === 3">
                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isIDetailPermission"
                      (click)="openDeleteModel(docs.id, 'Implementation')"></span>
                    <span class="cursor-pointer"
                      (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Implementation')">
                      <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                      <i class="fa fa-file-text-o fa-2x"
                        *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                      <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                      <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                      <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                      <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                      <i class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                    </span>
                    <div class="data-div">{{docs.fileName}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <!-- Template 2 -->
      <div *ngIf="impactAssessment.templateNo==2 || impactAssessment.templateNo==0">
        <mat-accordion id="AssessmentLegal">
          <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
            <mat-expansion-panel-header class="ia-mat-panel">
              <mat-panel-title>
                <span class="text-header inc-f">
                  Assessment - Legal
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row ml-2 my-4">
              <!-- <div class="col-lg-4">
              <label class="control-label fw">Assessment Team</label>
              <input type="text" class="form-control form-control-sm"
                [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                (keyup)="updateSectionLastEdited('AssessmentTeam')" [(ngModel)]="impactAssessment.assessmentTeam">
            </div> -->
              <div class="col-lg-4">
                <label class="control-label fw">Assessor</label>
                <mat-slide-toggle class="ml-2" [(ngModel)]="assessorToggle">Assign To Division</mat-slide-toggle>
                <mat-chip-grid #assessorList>
                  <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable" [removable]="removable"
                    (removed)="removeAssessor(assessor)">
                    {{assessor}}
                    <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">clear
                    </mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom"
                    #trigautoAssessor="matAutocompleteTrigger" (keydown)="getFilteredData('Assessor', $event)"
                    [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorInput
                    [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                    [matChipInputFor]="assessorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addAssessor($event)">
                </mat-chip-grid>
                <mat-autocomplete #assessorAutocomplete="matAutocomplete"
                  (optionSelected)="selectedAssessorEvent($event)">
                  <mat-option *ngFor="let assessor of (assessorToggle?searchedJurisdiction:searchedAssessor)"
                    [value]="assessorToggle?assessor.title:assessor.value">
                    {{assessorToggle?assessor.title:assessor.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Compliance Assessor</label>
                <mat-slide-toggle class="ml-2" [(ngModel)]="complianceToggle">Assign To Division</mat-slide-toggle>
                <mat-chip-grid #assessorDelList>
                  <mat-chip-row *ngFor="let assessor of assessorDelDD" [selectable]="selectable" [removable]="removable"
                    (removed)="removeAssessorDelegate(assessor)">
                    {{assessor}}
                    <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">clear
                    </mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom"
                    #trigautoAssessorDelegate="matAutocompleteTrigger"
                    (keydown)="getFilteredData('AssessorDelegate', $event)"
                    [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorDelInput
                    [formControl]="searchAssessorDelCntrl" [matAutocomplete]="assessorDelAutocomplete"
                    [matChipInputFor]="assessorDelList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                    (matChipInputTokenEnd)="addAssessorDelegate($event)">
                </mat-chip-grid>
                <mat-autocomplete #assessorDelAutocomplete="matAutocomplete"
                  (optionSelected)="selectedAssessorDelegateEvent($event)">
                  <mat-option *ngFor="let assessor of (complianceToggle?searchedJurisdiction:searchedAssessorDel)"
                    [value]="assessorToggle?assessor.title:assessor.value">
                    {{complianceToggle?assessor.title:assessor.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Action By</label>
                <div class="input-group input-group-sm">
                  <input matInput [matDatepicker]="assessmentDueDate"
                    [attr.disabled]="!isADetailPermission ? 'disabled' : null" (click)="assessmentDueDate.open()"
                    class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.assessmentDueDate"
                    name="AssessmentDueDate" (dateInput)="updateSectionLastEdited('Assessment')" />
                  <div class="input-group-append">
                    <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                      (click)="assessmentDueDate.open()"></span>
                    <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                  </div>
                </div>
                <mat-datepicker #assessmentDueDate (selectedChanged)="updateSectionLastEdited('Assessment')">
                </mat-datepicker>
              </div>
            </div>
            <div class="row ml-2 mt-1">
              <div class="col-lg-12">
                <div class="box-shadow p-2">
                  <div class="header-text">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                      (click)="isIADetails1 = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                      (click)="isIADetails1 = false"></span>
                    <span class="control-label fw">
                      Publication Proposal - Please provide a summary of what the publication is proposing
                    </span>
                  </div>
                  <div class="text-area-css overflow-auto"
                    *ngIf="iaDetailHistory && iaDetailHistory.assessmentDetails1.length > 0">
                    <div *ngFor="let detailItem of iaDetailHistory.assessmentDetails1">
                      <div class="pt-3" *ngIf="detailItem.itemTitle">
                        <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-css overflow-auto disabled-div"
                    *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.assessmentDetails1.length === 0"
                    [innerHTML]="impactAssessment.assessmentDetails1"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails1" id="assessmentDetails1"
                    [data]="impactAssessment.assessmentDetails1" class="f-16"
                    *ngIf="isADetailPermission && isIADetails1"
                    (keyUpEvent)="updateSectionLastEdited('Assessment')"></app-ck-editor>
                  <!-- <ckeditor [editor]="Editor" id="assessmentDetails1" class="f-16"
                    *ngIf="isADetailPermission && isIADetails1" [(ngModel)]="impactAssessment.assessmentDetails1"
                    (keyup)="updateSectionLastEdited('Assessment')">
                  </ckeditor> -->
                </div>
              </div>
            </div>
            <div class="row ml-2 mt-1">
              <div class="col-lg-12">
                <div class="box-shadow p-2">
                  <div class="header-text">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails2"
                      (click)="isIADetails2 = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails2"
                      (click)="isIADetails2 = false"></span>
                    <span class="control-label fw">
                      <!-- Impact - Please provide a summary of publication's impact on
                      business/operational/processes/policies -->
                      Applicability - Please describe the scope of application of the publication : Examples include
                      geographical scope/entities affected, effects on the asset/investor/tenant level
                    </span>
                  </div>
                  <div class="text-area-css overflow-auto"
                    *ngIf="iaDetailHistory && iaDetailHistory.assessmentDetails2.length > 0">
                    <div *ngFor="let detailItem of iaDetailHistory.assessmentDetails2">
                      <div class="pt-3" *ngIf="detailItem.itemTitle">
                        <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-css overflow-auto disabled-div"
                    *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.assessmentDetails2.length === 0"
                    [innerHTML]="impactAssessment.assessmentDetails2"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails2" id="assessmentDetails2"
                    [data]="impactAssessment.assessmentDetails2" class="f-16"
                    *ngIf="isADetailPermission && isIADetails2"
                    (keyUpEvent)="updateSectionLastEdited('Assessment')"></app-ck-editor>
                  <!-- <ckeditor [editor]="Editor" id="assessmentDetails2" class="f-16"
                    *ngIf="isADetailPermission && isIADetails2" [(ngModel)]="impactAssessment.assessmentDetails2"
                    (keyup)="updateSectionLastEdited('Assessment')">
                  </ckeditor> -->
                </div>
              </div>
            </div>

            <div class="row ml-2 pt-3">
              <span class="text-primary ml-1 fw" *ngIf="!isADetailPermission">Add Attachments</span>
              <div class="col-lg-3 cursor-pointer" *ngIf="isADetailPermission" (click)="uploadEvidenceAssessment()">
                <i class="fa fa-upload"></i>
                <span class="text-primary ml-1 fw">Add Attachments
                  <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
                </span>
                <input id="uploadEviAssessment" #myFileInput1 (change)="handleFileInput($event.target.files)"
                  type="file" multiple style="display: none" /><br />
              </div>
              <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                <ng-container *ngFor="let docs of impactAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === 1">
                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isADetailPermission"
                      (click)="openDeleteModel(docs.id, 'Assessment')"></span>
                    <span class="cursor-pointer"
                      (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Assessment')">
                      <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                      <i class="fa fa-file-text-o fa-2x"
                        *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                      <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                      <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                      <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                      <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                      <i class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                    </span>
                    <div class="data-div">{{docs.fileName}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion id="ImpactAnalysis">
          <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
            <mat-expansion-panel-header class="ia-mat-panel">
              <mat-panel-title>
                <span class="text-header inc-f">
                  Impact Analysis
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row ml-2 mt-1">
              <div class="col-lg-2">
                <label class="control-label fw">Capital/RWA Impact</label>
                <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.capitalRWAImpact">
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div class="col-lg-3">
                <label class="control-label fw">Implementation Type</label>
                <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                  (change)="updateSectionLastEdited('ImplementationType')"
                  [(ngModel)]="impactAssessment.implementationType">
                  <option *ngFor="let option of implementationType" value="{{option}}">{{option}}</option>
                </select>
              </div>
              <div class="col-lg-2">
                <label class="control-label fw">Project Reference</label>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="impactAssessment.projectReference"
                  [matAutocomplete]="auto" (change)="setProjectPreference()">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" class="refernce-autocomplete">
                  <mat-option [value]="'Not Applicable'">
                    Not Applicable
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="col-lg-3">
                <label class="control-label fw">
                  Impact Rating Lite
                  <span class="label label-default bg-default p5-20"
                    *ngIf="!impactAssessment.impactRatingLite">None</span>
                  <span class="label label-default bg-red p5-20"
                    *ngIf="impactAssessment.impactRatingLite === 'Very High'">Very
                    High</span>
                  <span class="label ml-2 label-default bg-orange p5-20"
                    *ngIf="impactAssessment.impactRatingLite === 'High'">High</span>
                  <span class="label ml-2 label-default bg-yellow p5-20"
                    *ngIf="impactAssessment.impactRatingLite === 'Medium'">Medium</span>
                  <span class="label ml-2 label-default bg-green p5-20"
                    *ngIf="impactAssessment.impactRatingLite === 'Low'">Low</span>
                </label>
                <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.impactRatingLite">
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                  <option value="Very High">Very High</option>
                </select>
              </div>
              <div class="col-lg-2">
                <a class="btn bg-g-lightGreen btn-sm" *ngIf="!isADetailPermission">Impact Rating Detail</a>
                <button class="btn bg-g-lightGreen btn-sm" [attr.disabled]="!isImpactRating ? true: null"
                  *ngIf="isADetailPermission" (click)="openImpactRating()">
                  Impact Rating Detail</button>
                <div class="mt-1">
                  <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.impactRating">Not
                    Performed</span>
                  <span class="label label-default bg-red p5-20"
                    *ngIf="impactAssessment.impactRating === 'Very High'">Very
                    High</span>
                  <span class="label ml-2 label-default bg-orange p5-20"
                    *ngIf="impactAssessment.impactRating === 'High'">High</span>
                  <span class="label ml-2 label-default bg-yellow p5-20"
                    *ngIf="impactAssessment.impactRating === 'Medium'">Medium</span>
                  <span class="label ml-2 label-default bg-green p5-20"
                    *ngIf="impactAssessment.impactRating === 'Low'">Low</span>
                </div>
              </div>
            </div>
            <div class="row ml-2 mt-1">
              <div class="col-lg-12">
                <div class="box-shadow p-2">
                  <div class="header-text">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="isRDetailPermission && !isRDetails"
                      (click)="isRDetails = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isRDetailPermission && isRDetails"
                      (click)="isRDetails = false"></span>
                    <span class="control-label fw">
                      Impact Details - Please provide additional details on Impact Analysis
                    </span>
                  </div>
                  <div class="text-area-css overflow-auto"
                    *ngIf="iaDetailHistory && iaDetailHistory.reviewDetails.length > 0">
                    <div *ngFor="let detailItem of iaDetailHistory.reviewDetails">
                      <div class="pt-3" *ngIf="detailItem.itemTitle">
                        <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-css overflow-auto disabled-div"
                    *ngIf="!isRDetailPermission && iaDetailHistory && iaDetailHistory.reviewDetails.length === 0"
                    [innerHTML]="impactAssessment.reviewDetails"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.reviewDetails" id="reviewDetails" class="f-16"
                    [data]="impactAssessment.reviewDetails" *ngIf="isRDetails"
                    (keyUpEvent)="updateSectionLastEdited('Review')"></app-ck-editor>
                  <!-- <ckeditor [editor]="Editor" id="reviewDetails" class="f-16" *ngIf="isRDetails"
                    [(ngModel)]="impactAssessment.reviewDetails" (keyup)="updateSectionLastEdited('Review')">
                  </ckeditor> -->
                </div>
              </div>
            </div>
            <div class="row ml-2 pt-3">
              <span class="text-primary ml-1 fw" *ngIf="!isRDetailPermission">Add Attachments</span>
              <div class="col-lg-3 cursor-pointer" *ngIf="isRDetailPermission" (click)="uploadEvidenceReview()">
                <i class="fa fa-upload"></i>
                <span class="text-primary ml-1 fw">Add Attachments
                  <i *ngIf="isReviewLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
                </span>
                <input id="uploadEviReview" #myFileInput2 (change)="handleReviewInput($event.target.files)" type="file"
                  multiple style="display: none" /><br />
              </div>
              <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                <ng-container *ngFor="let docs of impactAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === 2">
                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isRDetailPermission"
                      (click)="openDeleteModel(docs.id, 'Review')"></span>
                    <span class="cursor-pointer"
                      (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Review')">
                      <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                      <i class="fa fa-file-text-o fa-2x"
                        *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                      <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                      <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                      <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                      <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                      <i class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                    </span>
                    <div class="data-div">{{docs.fileName}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion id="AssessmentCompliance">
          <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
            <mat-expansion-panel-header class="ia-mat-panel">
              <mat-panel-title>
                <span class="text-header inc-f">
                  Assessment - Compliance
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row ml-2 my-4">

              <div class="col-lg-4">
                <label class="control-label fw">Assessor</label>
                <mat-slide-toggle class="ml-2" [(ngModel)]="assessorToggle">Assign To Division</mat-slide-toggle>
                <mat-chip-grid #assessorListN>
                  <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable" [removable]="removable"
                    (removed)="removeAssessor(assessor)">
                    {{assessor}}
                    <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">clear
                    </mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom"
                    #trigautoAssessor="matAutocompleteTrigger" (keydown)="getFilteredData('Assessor', $event)"
                    [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorInput
                    [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                    [matChipInputFor]="assessorListN" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addAssessor($event)">
                </mat-chip-grid>
                <mat-autocomplete #assessorAutocomplete="matAutocomplete"
                  (optionSelected)="selectedAssessorEvent($event)">
                  <mat-option *ngFor="let assessor of (assessorToggle?searchedJurisdiction:searchedAssessor)"
                    [value]="assessorToggle?assessor.title:assessor.value">
                    {{complianceToggle?assessor.title:assessor.name}}
                  </mat-option>
                </mat-autocomplete>

              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Status</label>
                <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                  (change)="updateSectionLastEdited('AssessmentStatus')"
                  [(ngModel)]="impactAssessment.assessmentStatus">
                  <option *ngFor="let option of assessmentStatus" value="{{option}}">{{option}}</option>
                </select>
              </div>
              <div class="col-lg-4">
                <label class="control-label fw">Last Edited</label>
                <div class="input-group input-group-sm">
                  <input matInput [matDatepicker]="assessmentLastEdited" disabled
                    class="form-control form-control-sm border-bottom"
                    [(ngModel)]="impactAssessment.assessmentLastEdited" name="AssessmentDueDate" />
                  <div class="input-group-append">
                    <span class="input-group-text fa fa-calendar" disabled></span>
                  </div>
                </div>
                <mat-datepicker #assessmentLastEdited></mat-datepicker>
              </div>
            </div>
            <div class="row ml-2 mt-1">
              <div class="col-lg-12">
                <div class="box-shadow p-2">
                  <div class="header-text">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="isIDetailPermission && !isIDetails4"
                      (click)="isIDetails4 = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIDetailPermission && isIDetails4"
                      (click)="isIDetails4 = false"></span>
                    <span class="control-label fw">
                      Impact - Please provide a summary of publication's impact on
                      business/operational/processes/policies
                    </span>
                  </div>
                  <div class="text-area-css overflow-auto"
                    *ngIf="iaDetailHistory && iaDetailHistory.implementationDetails.length > 0">
                    <div *ngFor="let detailItem of iaDetailHistory.implementationDetails">
                      <div class="pt-3" *ngIf="detailItem.itemTitle">
                        <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-css overflow-auto disabled-div"
                    *ngIf="!isIDetailPermission && iaDetailHistory && iaDetailHistory.implementationDetails.length === 0"
                    [innerHTML]="impactAssessment.implementationDetails"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.implementationDetails" id="implementationDetails"
                    [data]="impactAssessment.implementationDetails" class="f-16" *ngIf="isIDetails4"
                    (keyUpEvent)="updateSectionLastEdited('Implementation')"></app-ck-editor>
                  <!-- <ckeditor [editor]="Editor" id="implementationDetails" class="f-16" *ngIf="isIDetails4"
                    [(ngModel)]="impactAssessment.implementationDetails"
                    (keyup)="updateSectionLastEdited('Implementation')">
                  </ckeditor> -->
                </div>
              </div>
              <div class="col-lg-12">
                <button class="btn bg-g-lightGreen btn-sm float-right mt-2" (click)="addAssessmentDetails()">
                  Add Action</button>
              </div>
            </div>
            <div class="row ml-2 mt-1" *ngFor="let item of impactAssessment.assessmentDetailsList2;let i=index">
              <div class="col-lg-12">
                <div class="box-shadow p-2">
                  <div class="header-text">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails3"
                      (click)="isIADetails3 = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails3"
                      (click)="isIADetails3 = false"></span>
                    <span class="control-label fw">
                      Action Required - Please provide a summary of the actions needed to comply with publication
                      proposal
                    </span>
                  </div>
                  <div class="text-area-css overflow-auto" *ngIf="actionsRequiredArray">
                    <div>
                      <div class="pt-3" *ngIf="actionsRequiredArray">
                        <div class="f-16" [innerHTML]="sanitizeHtml(actionsRequiredArray[i])"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-css overflow-auto disabled-div"
                    *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.actionRequired.length === 0"
                    [innerHTML]="impactAssessment.assessmentDetailsList2"></div>
                  <app-ck-editor [(childVariable)]="item.actionsRequired" id="actionRequired" class="f-16"
                    [data]="item.actionsRequired" *ngIf="isADetailPermission && isIADetails3"
                    (keyUpEvent)="updateSectionLastEdited('Assessment')"></app-ck-editor>
                  <!-- <ckeditor [editor]="Editor" id="actionRequired" class="f-16"
                    *ngIf="isADetailPermission && isIADetails3" [(ngModel)]="item.actionsRequired"
                    (keyup)="updateSectionLastEdited('Assessment')">
                  </ckeditor> -->
                </div>
              </div>
              <div class="col-lg-12 mt-1">
                <div class="box-shadow p-2">
                  <div class="header-text">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails3"
                      (click)="isIADetails3 = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails3"
                      (click)="isIADetails3 = false"></span>
                    <span class="control-label fw">
                      Actions Taken - Please provide a summary of the actions taken to comply with publication proposal
                    </span>
                  </div>
                  <div class="text-area-css overflow-auto" *ngIf="actionsTakenArray">
                    <div>
                      <div class="pt-3" *ngIf="actionsTakenArray">
                        <div class="f-16" [innerHTML]="sanitizeHtml(actionsTakenArray[i])"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-css overflow-auto disabled-div"
                    *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.actionRequired.length === 0"
                    [innerHTML]="impactAssessment.assessmentDetailsList2"></div>
                  <app-ck-editor [(childVariable)]="item.actionsTaken" id="actionsTaken" class="f-16"
                    [data]="item.actionsTaken" *ngIf="isADetailPermission && isIADetails3"
                    (keyUpEvent)="updateSectionLastEdited('Assessment')"></app-ck-editor>
                  <!-- <ckeditor [editor]="Editor" id="actionsTaken" class="f-16" *ngIf="isADetailPermission && isIADetails3"
                    [(ngModel)]="item.actionsTaken" (keyup)="updateSectionLastEdited('Assessment')">
                  </ckeditor> -->
                </div>
              </div>
              <div class="col-lg-3 mt-3">
                <label class="control-label fw">Next Action Date</label>
                <div class="input-group input-group-sm">
                  <input matInput [matDatepicker]="assessmentDueDate"
                    [attr.disabled]="!isADetailPermission ? 'disabled' : null" (click)="assessmentDueDate.open()"
                    class="form-control form-control-sm border-bottom" [(ngModel)]="item.nextActionDate"
                    name="AssessmentDueDate" (dateInput)="updateSectionLastEdited('Assessment')" />
                  <div class="input-group-append">
                    <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                      (click)="assessmentDueDate.open()"></span>
                    <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                  </div>
                </div>
                <mat-datepicker #assessmentDueDate (selectedChanged)="updateSectionLastEdited('Assessment')">
                </mat-datepicker>
              </div>
              <div class="col-lg-3 mt-3">
                <label class="control-label fw">Action Status</label>
                <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                  (change)="updateSectionLastEdited('AssessmentActionStatus')" [(ngModel)]="item.actionStatus">
                  <option *ngFor="let option of assessmentActionStatus" value="{{option}}">{{option}}</option>
                </select>
              </div>
              <div class="col-lg-5 mt-3">
                <label class="control-label fw">Action Owner</label>
                <mat-chip-grid #actionOwnerList>
                  <mat-chip-row *ngFor="let owner of item.actionOwner|stringToArrayParent" [selectable]="selectable"
                    [removable]="removable" (removed)="removeMultipleActionOwner(owner,i)">
                    {{owner}}
                    <mat-icon matChipRemove *ngIf="removable && isADetailPermission"
                      class="clear-icons">clear</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom"
                    #trigautoOwner="matAutocompleteTrigger" (keydown)="getFilteredData('ActionOwner', $event)"
                    [attr.disabled]="!isADetailPermission ? 'disabled' : null" #ownerInput
                    [formControl]="searchActionOwnerCntrl" [matAutocomplete]="actionOwnerAutocomplete"
                    [matChipInputFor]="actionOwnerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                    (matChipInputTokenEnd)="addActionOwner($event,item.actionOwner,i)">
                </mat-chip-grid>
                <mat-autocomplete #actionOwnerAutocomplete="matAutocomplete"
                  (optionSelected)="selectedMultipleActionOwnerEvent($event,item.actionOwner,i)">
                  <mat-option *ngFor="let owner of searchedActionOwner" [value]="owner.value">
                    {{owner.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="col-lg-1 mt-3">
                <span *ngIf="impactAssessment.assessmentDetailsList2.length>1" class="cursor-pointer fg-red"
                  (click)="removeAssessmentDetails(i)"><span class="fa fa-trash"></span>
                  <span class="text-primary ml-1">Delete</span>
                </span>
              </div>
            </div>
            <div class="row ml-2 pt-3">
              <span class="text-primary ml-1 fw" *ngIf="!isIDetailPermission">Add Attachments</span>
              <div class="col-lg-3 cursor-pointer" *ngIf="isIDetailPermission" (click)="uploadEvidenceImplementation()">
                <i class="fa fa-upload"></i>
                <span class="text-primary ml-1 fw">Add Attachments
                  <i *ngIf="isImplementationLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
                </span>
                <input id="uploadEviImplementation" #myFileInput3
                  (change)="handleImplementationInput($event.target.files)" type="file" multiple
                  style="display: none" /><br />
              </div>
              <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                <ng-container *ngFor="let docs of impactAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === 3">
                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isIDetailPermission"
                      (click)="openDeleteModel(docs.id, 'Implementation')"></span>
                    <span class="cursor-pointer"
                      (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Implementation')">
                      <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                      <i class="fa fa-file-text-o fa-2x"
                        *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                      <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                      <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                      <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                      <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                      <i class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                    </span>
                    <div class="data-div">{{docs.fileName}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <!-- Template 3-->
      <div *ngIf="impactAssessment.templateNo==3">
        <app-impact-assessment-template3 [(impactAssessment)]="impactAssessment" [isIADetails3]="isIADetails3"
          [impactDetails]="impactDetails" [actionsRequiredArray]="actionsRequiredArray"
          (selectedAssessorEventfunc)="selectedAssessorEvent($event)" [iaDetailHistory]="iaDetailHistory"
          [implementationDetails]="implementationDetails" [isADetailPermission]="isADetailPermission"
          (updateSectionLastEdited)="updateSectionLastEdited($event)" [isImplementationLoader]="isImplementationLoader"
          [impactAssessmentDocument]="impactAssessmentDocument" [assessmentStatus]="assessmentStatus"
          [isIADetails2]="isIADetails2" [isIADetails1]="isIADetails1" [isIDPermission]="isIDPermission"
          [filterType]="filterType" [isIDetails]="isIDetails" [isIDetailPermission]="isIDetailPermission"
          [implementationType]="implementationType" [implementationStatus]="implementationStatus"
          [publicationDetails]="publicationDetails" (uploadEvidenceImplementationFunc)="uploadEvidenceImplementation()"
          [assessorDD]="assessorDD" [actionOwnerDD]="actionOwnerDD" [imptOwnerDD]="imptOwnerDD"
          (removeAssessorfunc)="removeAssessor($event)" (removeActionOwnerFunc)="removeActionOwner($event)"
          (checkImplementationDetailRequiredFunc)="checkImplementationDetailRequired($event)"
          [searchedAssessor]="searchedAssessor" [searchedActionOwner]="searchedActionOwner"
          [searchedImptOwner]="searchedImptOwner" (getFilteredDatafunc)="getFilteredDataCall($event)"
          (openDeleteModelFunc)="openDeleteModelCall($event)"
          (handleImplementationInputFunc)="handleImplementationInput($event)"
          (removeImplementationOwnerFunc)="removeImplementationOwner($event)"
          (downloadDocumentFunc)="downloadDocumentCall($event)" (setProjectPreferenceFunc)="setProjectPreference()"
          [searchAssessorCntrl]="searchAssessorCntrl" [searchActionOwnerCntrl]="searchActionOwnerCntrl"
          [searchImptOwnerCntrl]="searchImptOwnerCntrl"
          (selectedImplementationOwnerEventFunc)="selectedImplementationOwnerEvent($event)">
        </app-impact-assessment-template3>

      </div>
    </div>
  </div>
</div>
<div class="card" *ngIf="!isAuthorised">
  <div class="crad-body p-2">
    <div>You are not authorised to see this impact assessment.</div>
  </div>
</div>